<template>
<div class="chapter">
<div class="inner_page">
<h3 class="t3b">CONTENTS
</h3>
<p class="t2">
<a href="#/Text/Section0004">CHAPTER I</a>
</p>
<p class="t2">
THE GERMAN RETREAT UPON THE ARRAS-SOISSONS FRONT
</p>
<p class="contents">
Hindenburg's retreat—The advance of the Fifth and Fourth
Armies—Capture of Bapaume and Peronne—Atrocious devastation by the
Germans—Capture of guns at Selency—Definition of the
Hindenburg Line—General survey
</p>
<p class="t2">
<a href="#/Text/Section0005">CHAPTER II</a>
</p>
<p class="t2">
THE BATTLE OF ARRAS
</p>
<p class="calibre7">
April 9 to April 23, 1917.
</p>
<p class="contents">
Vast preparations—Attack of Snow's Seventh Corps—The Ibex
Trench—Attack of Haldane's Sixth Corps—Attack of Fergusson's
Seventeenth Corps—A Scottish Front—The splendid Canadians—Capture
of Mouchy—Essex and Newfoundland—A glorious episode—The
Chemical Works—Extension of the battle to the north—Desperate
fight of the Australians at Bullecourt
</p>
<p class="t2">
<span href="#/Text/Section0006" title="Link target outside of Sample">CHAPTER III</span>
</p>
<p class="t2">
OPERATIONS IN THE ARRAS SECTOR FROM APRIL 23 ONWARDS
</p>
<p class="contents">
Advance of April 23—Middlesex and Argyll—Grand fighting of the
Fifteenth Division—H.A.C. at Gavrelle—Operations of May 3—The
Gavrelle Windmill—Loss of Fresnoy—Capture of Rœux—The
long fight at Bullecourt
</p>
<p class="t2">
<span href="#/Text/Section0007" title="Link target outside of Sample">CHAPTER IV</span>
</p>
<p class="t2">
THE BATTLE OF MESSINES
</p>
<p class="contents">
Plumer's long vigil—The great mines—Advance of Australians—Of New
Zealanders—Of the Twenty-fifth Division—Of the Irish
<a id="Pviii" title="{viii}"></a>
Divisions—Death of Major Redmond—Advance of Nineteenth Division—Of
the Forty-first Division—Of the Forty-seventh Division—Of the
Twenty-fourth Division—General results
</p>
<p class="t2">
<span href="#/Text/Section0008" title="Link target outside of Sample">CHAPTER V</span>
</p>
<p class="t2">
OPERATIONS FROM JUNE 10 TO JULY 31
</p>
<p class="contents">
Fighting round Lens—Good work of Canadians and Forty-sixth
Division—Action on the Yser canal—Great fight and eventual annihilation
of 2nd K.R.R. and 1st Northampton—An awful ordeal—Exit Russia
</p>
<p class="t2">
<span href="#/Text/Section0009" title="Link target outside of Sample">CHAPTER VI</span>
</p>
<p class="t2">
THE THIRD BATTLE OF YPRES
</p>
<p class="t2">
July 31, 1917
</p>
<p class="contents">
Attack of July 31—Advance of the Guards—Of the Welsh—Capture of
Pilkem—Capture of St. Julien by Thirty-ninth Division—Advance
of Fifty-fifth Division—Advance of Jacob's Second Corps—General
results
</p>
<p class="t2">
<span href="#/Text/Section0010" title="Link target outside of Sample">CHAPTER VII</span>
</p>
<p class="t2">
THE THIRD BATTLE OF YPRES
</p>
<p class="t2">
August 1 to September 6
</p>
<p class="contents">
Dreadful weather—German reaction—Attack of August 16—Advance of
Cavan's Corps—Capture of Langemarck—Dreadful losses of the two
Irish Divisions—Failure in the south—Splendid field-gunners—The
Forty-second Division upon September 6
</p>
<p class="t2">
<span href="#/Text/Section0011" title="Link target outside of Sample">CHAPTER VIII</span>
</p>
<p class="t2">
THE THIRD BATTLE OF YPRES
</p>
<p class="t2">
September 6 to October 3, 1917
</p>
<p class="contents">
Engagement of Plumer's Second Army—Attack of September 20—Fine
advance of Fifty-fifth Division—Advance of the Ninth
<a id="Pix" title="{ix}"></a>
Division—Of the Australians—Strong counter-attack upon the Thirty-third
Division—Renewed advance on September 20—Continued
rain—Desperate fighting
</p>
<p class="t2">
<span href="#/Text/Section0012" title="Link target outside of Sample">CHAPTER IX</span>
</p>
<p class="t2">
THE THIRD BATTLE OF YPRES
</p>
<p class="t2">
October 4 to November 10, 1917
</p>
<p class="contents">
Attack of October 4—Further advance of the British line—Splendid
advance of second-line Territorials—Good work of H.A.C. at
Reutel—Abortive action of October 12—Action of October 26—Heavy
losses at the south end of the line—Fine fighting by the Canadian
Corps—Capture of Paschendaale—General results of third battle
of Ypres
</p>
<p class="t2">
<span href="#/Text/Section0013" title="Link target outside of Sample">CHAPTER X</span>
</p>
<p class="t2">
THE BATTLE OF CAMBRAI
</p>
<p class="contents">
First phase, November 20—Tanks <i class="calibre9">en masse</i>—Attack on the Tunnel
Trench—Byng's great advance—Fine work of the Sixty-second
Division—Hard fighting of Pulteney's Third Corps—Exploit of Fort
Garry Horse—Second day of battle—Rally of Germans—Capture
of Bourlon Wood by Fortieth Division—Attack by the Guards
on La Fontaine
</p>
<p class="t2">
<span href="#/Text/Section0014" title="Link target outside of Sample">CHAPTER XI</span>
</p>
<p class="t2">
THE BATTLE OF CAMBRAI.
</p>
<p class="contents">
Second phase of battle on November 30—Great German attack—Disaster
to three divisions—Desperate fight of Twenty-ninth Division—Fine
advance by the Guards—Capture and recapture of Gouzeaucourt—Hard
battle in the Bourlon Sector—Heavy losses of the
Germans—Retraction of the British line</p>
<p class="calibre7">
<a id="Pxi" title="{xi}"></a>
</p>
<p class="t2">
MAPS AND PLANS
</p>
<p class="contents">
<a href="#/Text/Section0004#img-008">Fighting Line, February 24, 1917, and Fighting Line,
March 1, 1917</a>
</p>
<p class="contents">
<a href="#/Text/Section0005#img-039">The Arras Front</a>
</p>
<p class="contents">
<a href="#/Text/Section0005#img-063">Chart of Order of Battle, Arras, April 9, 1917</a>
</p>
<p class="contents">
<span href="#/Text/Section0007#img-111" title="Link target outside of Sample">Order of Battle, Messines, June 7, 1917</span>
</p>
<p class="contents">
<span href="#/Text/Section0010#img-165" title="Link target outside of Sample">Line of Battle, August 16, 1917</span>
</p>
<p class="contents">
<span href="#/Text/Section0010#img-178" title="Link target outside of Sample">The Ypres Front</span>
</p>
<p class="contents">
<span href="#/Text/Section0011#img-201" title="Link target outside of Sample">Third Ypres Battle, September 26</span>
</p>
<p class="contents">
<span href="#/Text/Section0012#img-207" title="Link target outside of Sample">Order of Battle, October 4, 1917</span>
</p>
<p class="contents">
<span href="#/Text/Section0013#img-239" title="Link target outside of Sample">Fighting Line, November 20, 1917</span>
</p>
<p class="contents">
<span href="#/Text/Section0013#img-259" title="Link target outside of Sample">Battle Line of Third Army, November 20, 1917</span>
</p>
<p class="contents">
<span href="#/Text/Section0013#img-269" title="Link target outside of Sample">Fighting Line, November 30, 1917</span>
</p>
<p class="contents">
<span href="#/Text/Section0014#img-281" title="Link target outside of Sample">Battle Order of Third Army, November 30, 1917</span></p>
<p class="calibre7"><a id="chap01"></a></p>
<p class="calibre7"><a id="P1" title="{1}"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?66ed6a3c